import axios from "axios";

export const DEFAULT_BASE_URL = process.env.VUE_APP_API_BASE_URL || "/app-api";
export const AUTH_TOKEN_KEY = "bead_login_token";

export function getStoredAuthToken() {
  try {
    return window.localStorage.getItem(AUTH_TOKEN_KEY) || "";
  } catch (error) {
    return "";
  }
}

export function getStoredSession() {
  return getStoredAuthToken();
}

export function setStoredAuthToken(token) {
  try {
    if (token) {
      window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(AUTH_TOKEN_KEY);
    }
  } catch (error) {
    // Ignore storage failures in restricted browser contexts.
  }
}

export function createHttpClient(baseURL = DEFAULT_BASE_URL) {
  const client = axios.create({
    baseURL,
    timeout: 30000,
    withCredentials: true
  });

  client.interceptors.request.use((config) => {

    const token = getStoredAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.token = token;
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => {
      const payload = response.data || {};
      if (payload.ok === false) {
        return Promise.reject(new Error(payload.message || "Request failed"));
      }
      if (typeof payload.code === "number" && payload.code !== 0) {
        return Promise.reject(new Error(payload.msg || payload.message || "Request failed"));
      }
      return payload.data != null ? payload.data : payload;
    },
    (error) => {
      const message = error?.response?.data?.msg || error?.response?.data?.message || error.message || "Request failed";
      return Promise.reject(new Error(message));
    }
  );

  return client;
}
